import { Box } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DoneIcon from '@mui/icons-material/Done';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { stepperStyles as classes } from './StepperStyles';
import StepperConnector from './StepperConnector';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { businessMapping } from '../../services/businessMapping';
import {
  YOUR_INFORMATION_BUSINESS,
  PERSONAL_INFORMATION,
  YOUR_ACCOUNT_BUSINESS,
  YOUR_ACCOUNT,
  YOUR_CONSENT,
  BASIC_INFORMATION,
  REVIEW_INFORMATION,
} from '../../constants';
import {
  isCDIraproduct,
  isCDproduct,
  isIRAEducativaProduct,
  isWebComponentFlow,
} from '../commonCode';
import { productMapping } from '../../services/productMapping';

export default function StepperWizard(props) {
  const { t } = useTranslation();
  const baseContext = isWebComponentFlow();
  const { productName, language, flowInvitation } = baseContext;
  const { steps } = props;

  const commonTernary = (condition, result1, result2) => {
    if (condition) {
      return result1;
    }
    return result2;
  };

  const businessESP = businessMapping(productName) && language === 'ES';
  return (
    <Box component="div" sx={classes.root}>
      <Box
        component="div"
        sx={commonTernary(language === 'EN', classes.stepperWrapperEng, classes.stepperWrapperEsp)}
      >
        <StepperConnector />
        {isCDproduct(productName) ||
        isCDIraproduct(productName) ||
        isIRAEducativaProduct(productName) ? (
          <Box component="div" sx={classes.iconWrapper}>
            <Box component="div" sx={[classes.icon, classes.firstIcon]}>
              <div className="icon_border">
                <Box sx={[classes.steps, steps == 0 ? classes.current : classes.fullycompleted]}>
                  <span className="check_step">
                    {steps > 0 ? (
                      <DoneIcon className="icon" />
                    ) : (
                      <FiberManualRecordIcon className="icon" style={{ color: '#661C69' }} />
                    )}
                  </span>
                </Box>
              </div>

              <Box
                style={{ maxWidth: '100px' }}
                sx={commonTernary(
                  steps >= 0,
                  commonTernary(
                    businessMapping(productName),
                    classes.businessLabelCompleted,
                    classes.labelCompleted
                  ),
                  commonTernary(businessMapping(productName), classes.businessLabel, classes.label)
                )}
              >
                {businessMapping(productName)
                  ? t(YOUR_INFORMATION_BUSINESS, {
                      defaultValue: YOUR_INFORMATION_BUSINESS,
                    })
                  : t(BASIC_INFORMATION, { defaultValue: BASIC_INFORMATION })}
              </Box>
            </Box>

            <Box
              sx={flowInvitation === 'invitation-form' ? classes.inviStyle : classes.icon}
              style={{ left: '35%' }}
            >
              <div className="icon_border">
                <Box
                  component="div"
                  sx={[
                    classes.steps,
                    steps < 1
                      ? classes.upcoming
                      : steps <= 2
                      ? classes.current
                      : classes.fullycompleted,
                  ]}
                >
                  <span className="check_step">
                    {steps < 1 ? (
                      <FiberManualRecordIcon className="icon" style={{ color: '#D0D0D0' }} />
                    ) : steps === 1 || steps === 2 ? (
                      <FiberManualRecordIcon className="icon" style={{ color: '#661C69' }} />
                    ) : (
                      <DoneIcon className="icon" />
                    )}
                  </span>
                </Box>
              </div>
              <Box
                component="span"
                style={businessMapping(productName) ? { maxWidth: '100px' } : { maxWidth: '50px' }}
                sx={commonTernary(
                  steps >= 1,
                  commonTernary(
                    businessMapping(productName),
                    classes.businessLabelCompleted,
                    classes.labelCompleted
                  ),
                  commonTernary(businessMapping(productName), classes.businessLabel, classes.label)
                )}
              >
                {businessMapping(productName)
                  ? t(YOUR_ACCOUNT_BUSINESS, { defaultValue: YOUR_ACCOUNT_BUSINESS })
                  : t(PERSONAL_INFORMATION, { defaultValue: PERSONAL_INFORMATION })}
              </Box>
            </Box>

            <Box component="div" sx={classes.icon} style={{ left: '63%' }}>
              <div className="icon_border">
                <Box
                  component="div"
                  sx={[
                    classes.steps,
                    steps < 3
                      ? classes.upcoming
                      : steps === 3
                      ? classes.current
                      : classes.fullycompleted,
                  ]}
                >
                  <span className="check_step">
                    {steps < 3 ? (
                      <FiberManualRecordIcon className="icon" style={{ color: '#D0D0D0' }} />
                    ) : steps === 3 ? (
                      <FiberManualRecordIcon className="icon" style={{ color: '#661C69' }} />
                    ) : (
                      <DoneIcon className="icon" />
                    )}
                  </span>
                </Box>
              </div>

              <Box
                component="span"
                style={language === 'EN' ? { maxWidth: '73px' } : { maxWidth: '80px' }}
                sx={commonTernary(
                  steps >= 3,
                  commonTernary(
                    businessMapping(productName),
                    classes.businessLabelCompleted,
                    classes.labelCompleted
                  ),
                  commonTernary(businessMapping(productName), classes.businessLabel, classes.label)
                )}
              >
                {t(REVIEW_INFORMATION, { defaultValue: REVIEW_INFORMATION })}
              </Box>
            </Box>

            <Box component="div" sx={classes.icon} style={{ left: '95%' }}>
              <div className="icon_border">
                <Box
                  component="div"
                  sx={[classes.steps, steps <= 3 ? classes.upcoming : classes.current]}
                >
                  <span className="check_step">
                    {steps <= 3 ? (
                      <FiberManualRecordIcon className="icon" style={{ color: '#D0D0D0' }} />
                    ) : (
                      <FiberManualRecordIcon className="icon" style={{ color: '#661C69' }} />
                    )}
                  </span>
                </Box>
              </div>

              <Box
                component="span"
                style={language === 'EN' ? { maxWidth: '73px' } : { maxWidth: '80px' }}
                sx={{
                  ...commonTernary(
                    steps > 3,
                    commonTernary(
                      businessMapping(productName),
                      classes.businessLabelCompleted,
                      classes.labelCompleted
                    ),
                    commonTernary(
                      businessMapping(productName),
                      classes.businessLabel,
                      classes.label
                    )
                  ),
                  ...(businessESP && { marginLeft: '-10px' }),
                }}
              >
                {t(YOUR_CONSENT, { defaultValue: YOUR_CONSENT })}
              </Box>
            </Box>
          </Box>
        ) : (
          <Box component="div" sx={classes.iconWrapper}>
            <Box component="div" sx={classes.icon}>
              <Box component="div" sx={[classes.steps, steps >= 1 ? classes.fullycompleted : '']}>
                <span>1</span>
              </Box>
              <Box
                component="span"
                style={{ maxWidth: '100px' }}
                sx={commonTernary(
                  steps >= 1,
                  commonTernary(
                    businessMapping(productName),
                    classes.businessLabelCompleted,
                    classes.labelCompleted
                  ),
                  commonTernary(businessMapping(productName), classes.businessLabel, classes.label)
                )}
              >
                {businessMapping(productName)
                  ? t(YOUR_INFORMATION_BUSINESS, {
                      defaultValue: YOUR_INFORMATION_BUSINESS,
                    })
                  : t(PERSONAL_INFORMATION, { defaultValue: PERSONAL_INFORMATION })}
              </Box>
            </Box>

            <Box
              component="div"
              sx={flowInvitation === 'invitation-form' ? classes.inviStyle : classes.icon}
              style={{ left: '47%' }}
            >
              <Box component="div" sx={[classes.steps, steps >= 2 ? classes.fullycompleted : '']}>
                <span>2</span>
              </Box>
              <Box
                component="span"
                style={businessMapping(productName) ? { maxWidth: '100px' } : { maxWidth: '50px' }}
                sx={commonTernary(
                  steps >= 2,
                  commonTernary(
                    businessMapping(productName),
                    classes.businessLabelCompleted,
                    classes.labelCompleted
                  ),
                  commonTernary(businessMapping(productName), classes.businessLabel, classes.label)
                )}
              >
                {businessMapping(productName)
                  ? t(YOUR_ACCOUNT_BUSINESS, { defaultValue: YOUR_ACCOUNT_BUSINESS })
                  : t(YOUR_ACCOUNT, { defaultValue: YOUR_ACCOUNT })}
              </Box>
            </Box>

            <Box component="div" sx={classes.icon} style={{ left: '93%' }}>
              <Box component="div" sx={[classes.steps, steps === 3 ? classes.fullycompleted : '']}>
                <span>{flowInvitation === 'invitation-form' ? 2 : 3}</span>
              </Box>
              <Box
                component="span"
                style={language === 'EN' ? { maxWidth: '73px' } : { maxWidth: '80px' }}
                sx={{
                  ...commonTernary(
                    steps >= 3,
                    commonTernary(
                      businessMapping(productName),
                      classes.businessLabelCompleted,
                      classes.labelCompleted
                    ),
                    commonTernary(
                      businessMapping(productName),
                      classes.businessLabel,
                      classes.label
                    )
                  ),
                  ...(businessESP && { marginLeft: '-10px' }),
                }}
              >
                {t(YOUR_CONSENT, { defaultValue: YOUR_CONSENT })}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

StepperWizard.propTypes = {
  steps: PropTypes.number,
};
